
import {ApolloClient,InMemoryCache} from '@apollo/client';

import  {BASE_URL} from'../static/constant'
export default new ApolloClient({
    cache: new InMemoryCache(),
    uri: BASE_URL,
});
